import React, { Fragment, useContext, useRef } from "react";
import { FiMinus, FiPlus, FiX } from "react-icons/fi";
import './index.scss'

import { handleQtyProps, ProductProps } from "components";
import { BsBagPlusFill } from "react-icons/bs";
import { ProductType } from "slices/products";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, getCartSelector, updateFromCart } from "slices/cart";

interface Props {
    SetShow: React.Dispatch<React.SetStateAction<boolean>>
    product: ProductType
    cartIndex: number
    handleAddToCart: () => void
    handleUpdateCart: () => void
    id: string
}

export function PopUp(props: Props) {

    const cartItems = useSelector(getCartSelector)
    const dispatch = useDispatch()
    const popUp = useRef(null)
    const inputRef = useRef(null)

    function handleCick(event: any) {
        if (event.target.className.startsWith) {
            if (!event?.target.className.startsWith('popUp')) {
                props.SetShow(false)
            }
        }

    }


    function handleAddToCart() {
        const cartItem = { ...props.product, id: props.id }
        dispatch(addToCart(cartItem))
    }

    function handleUpdateCart() {
        let cartItem = { ...cartItems[props.cartIndex] }
        if (props.cartIndex !== -1) {
            cartItem.amount -= 1
            dispatch(updateFromCart(cartItem))
        }
    }

    function handleChange({ target }: React.ChangeEvent<HTMLInputElement>) {
        const cartItem = { ...cartItems[props.cartIndex] }
        if (props.cartIndex !== -1 && !props.product.stock) {
            cartItem.amount = parseInt(target.value)
            dispatch(updateFromCart(cartItem))
        }
    }


    return (
        <Fragment>
            <div className="fixed-body" onClick={handleCick}>
                <div className="popUp" ref={popUp}>
                    <div className="popUp-left">
                        <img className="popUp-left-img" src={props.product.img} alt={props.product.name} />
                    </div>
                    <div className="popUp-right">
                        <div className="popUp-right-name">{props.product.name}</div>
                        {props.product.stock ? (<span className="popUp-right-title">out of stock</span>) : (<span className="popUp-right-title available">in stock</span>)}
                        <div className="popUp-right-body">
                            Most fresh vegetables are low in calories and have a water content in excess of 70 percent, with
                            only
                            about 3.5 percent
                            protein and less than 1 percent fat. ... The root vegetables include beets, carrots, radishes, sweet
                            potatoes, and
                            turnips. Stem vegetables include asparagus and kohlrabi.
                        </div>
                        <div className="popUp-right-price">${props.product.price}</div>
                        <div className="popUp-right-cart">
                            {props.cartIndex !== -1 ? (
                                <Fragment>
                                    <div className="popUp-right-cart-right" onClick={handleUpdateCart} >{<FiMinus />}</div>
                                    <input onChange={handleChange} ref={inputRef} value={cartItems[props.cartIndex].amount} type="text" className="popUp-right-cart-quantity" />
                                    <div className="popUp-right-cart-left" onClick={handleAddToCart}>{<FiPlus />}</div>
                                </Fragment>
                            ) : (<i className="popUp-right-cart-add" onClick={props.handleAddToCart} ><BsBagPlusFill /></i>)}
                        </div>

                        <div className="popUp-right-bottom">
                            <span className="popUp-right-bottom-head">category: </span>
                            <span className="popUp-right-bottom-categories">
                                <div className="popUp-right-bottom-categories-category">fresh vegetable</div>
                            </span>
                            <div className="popUp-right-bottom-tags">
                                <span className="popUp-right-bottom-tags-tag ml-0">lettuce</span>
                                <span className="popUp-right-bottom-tags-tag">fresh vegetable</span>
                            </div>
                        </div>
                    </div>
                </div>
                <i className="close" onClick={() => { props.SetShow(false) }}>{<FiX />}</i>
            </div>
            <div className="close-shadow">
            </div>
        </Fragment>
    )
}